/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Statsbar_Activediscounts2Inputs */

const id_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskon Aktif`)
};

const ms_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskaun Aktif`)
};

const da_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive rabatter`)
};

const de_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Rabatte`)
};

const en_us2_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Discounts`)
};

const es_es2_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descuentos activos`)
};

const es_mx2_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descuentos activos`)
};

const fil_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Aktibong Diskwento`)
};

const fr_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réductions actives`)
};

const it_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sconti attivi`)
};

const hu_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktív kedvezmények`)
};

const nl_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actieve kortingen`)
};

const no_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive rabatter`)
};

const pl_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktywne promocje`)
};

const pt_br2_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descontos ativos`)
};

const pt_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descontos ativos`)
};

const ro_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduceri active`)
};

const fi_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiiviset alennukset`)
};

const sv_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiva rabatter`)
};

const vi_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảm giá đang hoạt động`)
};

const tr_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif İndirimler`)
};

const cs_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivní slevy`)
};

const bg_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активни отстъпки`)
};

const ru_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активные скидки`)
};

const uk_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активних знижок`)
};

const ar_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الخصومات النشطة`)
};

const hi_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रिय छूट`)
};

const th_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่วนลดที่กำลังใช้งาน`)
};

const ja_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティブな割引`)
};

const zh_cn2_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前折扣`)
};

const zh_hant1_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前折扣`)
};

const ko_home_statsbar_activediscounts2 = /** @type {(inputs: Home_Statsbar_Activediscounts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`진행 중인 할인`)
};

/**
* | output |
* | --- |
* | "Active Discounts" |
*
* @param {Home_Statsbar_Activediscounts2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_statsbar_activediscounts2 = /** @type {((inputs?: Home_Statsbar_Activediscounts2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Statsbar_Activediscounts2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_statsbar_activediscounts2(inputs)
	if (locale === "ms") return ms_home_statsbar_activediscounts2(inputs)
	if (locale === "da") return da_home_statsbar_activediscounts2(inputs)
	if (locale === "de") return de_home_statsbar_activediscounts2(inputs)
	if (locale === "en-US") return en_us2_home_statsbar_activediscounts2(inputs)
	if (locale === "es-ES") return es_es2_home_statsbar_activediscounts2(inputs)
	if (locale === "es-MX") return es_mx2_home_statsbar_activediscounts2(inputs)
	if (locale === "fil") return fil_home_statsbar_activediscounts2(inputs)
	if (locale === "fr") return fr_home_statsbar_activediscounts2(inputs)
	if (locale === "it") return it_home_statsbar_activediscounts2(inputs)
	if (locale === "hu") return hu_home_statsbar_activediscounts2(inputs)
	if (locale === "nl") return nl_home_statsbar_activediscounts2(inputs)
	if (locale === "no") return no_home_statsbar_activediscounts2(inputs)
	if (locale === "pl") return pl_home_statsbar_activediscounts2(inputs)
	if (locale === "pt-BR") return pt_br2_home_statsbar_activediscounts2(inputs)
	if (locale === "pt") return pt_home_statsbar_activediscounts2(inputs)
	if (locale === "ro") return ro_home_statsbar_activediscounts2(inputs)
	if (locale === "fi") return fi_home_statsbar_activediscounts2(inputs)
	if (locale === "sv") return sv_home_statsbar_activediscounts2(inputs)
	if (locale === "vi") return vi_home_statsbar_activediscounts2(inputs)
	if (locale === "tr") return tr_home_statsbar_activediscounts2(inputs)
	if (locale === "cs") return cs_home_statsbar_activediscounts2(inputs)
	if (locale === "bg") return bg_home_statsbar_activediscounts2(inputs)
	if (locale === "ru") return ru_home_statsbar_activediscounts2(inputs)
	if (locale === "uk") return uk_home_statsbar_activediscounts2(inputs)
	if (locale === "ar") return ar_home_statsbar_activediscounts2(inputs)
	if (locale === "hi") return hi_home_statsbar_activediscounts2(inputs)
	if (locale === "th") return th_home_statsbar_activediscounts2(inputs)
	if (locale === "ja") return ja_home_statsbar_activediscounts2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_statsbar_activediscounts2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_statsbar_activediscounts2(inputs)
	return ko_home_statsbar_activediscounts2(inputs)
});
export { home_statsbar_activediscounts2 as "home.statsBar.activeDiscounts" }